import { useState, useEffect } from "react";
import { getChat, getChatMessages, getUserInfo } from "../../../../../utils/services/user.service";

export const useChatData = (userdata, otcNameParam, projectParam) => {
  const [chatData, setChatData] = useState([]);
  const [roomData, setroomData] = useState([]);
  const [ChatMessage, setChatMessage] = useState([]);
  const [selectedChat, setSelectedChat] = useState(false);
  const [getBlock, setBlock] = useState(false);
  const [getBlock1, setBlock1] = useState(false);
  const [show, setShow] = useState(false);
  const [readStatus, setReadStaatus] = useState(null);

  const getStatusesWithIds = (chatData, userId) => {
    return chatData
      .map((room) => {
        if (room.support_user_id === userId) {
          return { _id: room._id, status: room.support_read_status };
        } else if (room.user_id === userId) {
          return { _id: room._id, status: room.user_read_status };
        }
        return null;
      })
      .filter((status) => status !== null);
  };

  const getChatData = () => {
    const payload = {
      type: "all",
      limit: 10,
      page_number: 1,
      user_id: userdata,
    };
    getChat(payload)
      .then((data) => {
        const dta = data.data.chats;
        const privateChats = dta.filter((chat) => chat.type === "private" || chat.type === "user");
        const roomChats = dta.filter((chat) => chat.type === "room" || chat.type === "otc-room");
        const otcRoomChats = dta.filter((chat) => chat.type === "otc-room");

        setChatData(privateChats);
        setroomData(roomChats);
        if (otcRoomChats.length > 0) {
          setSelectedChat(true);
        } else {
          setSelectedChat(false);
        }
        setBlock1(false);
        setBlock(false);
      })
      .catch((error) => {
        console.error("Error fetching chat data:", error);
      });
  };

  useEffect(() => {
    getChatData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userdata]);

  useEffect(() => {
    const readStatuses = getStatusesWithIds(chatData, userdata);
    setReadStaatus(readStatuses);
  }, [chatData, userdata]);

  const fetchChats = async (id) => {
    try {
      const requestData = { chat_id: id };
      const response = await getChatMessages(requestData);
      if (response.data.chat_reply) {
        setChatMessage(response.data.chat_reply);
      }
    } catch (error) {
      setChatMessage([]);
      console.error("Error fetching chats:", error);
    }
  };

  const getUsers = () => {
    getUserInfo()
      .then((res) => {
        if (res?.data?.User.chat_status !== "enabled") {
          setShow(true);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getUsers();
  }, []);

  return {
    chatData,
    roomData,
    ChatMessage,
    selectedChat,
    getBlock,
    getBlock1,
    show,
    readStatus,
    setChatData,
    setroomData,
    setChatMessage,
    getChatData,
    fetchChats,
  };
};

